import { render, staticRenderFns } from "./reportDetails.vue?vue&type=template&id=575b3c84&scoped=true"
import script from "./reportDetails.vue?vue&type=script&lang=js"
export * from "./reportDetails.vue?vue&type=script&lang=js"
import style0 from "./reportDetails.vue?vue&type=style&index=0&id=575b3c84&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575b3c84",
  null
  
)

export default component.exports